import { i18nAlarmPage } from './alarm.i18n';
import { i18nAssetPage } from './asset.i18n';
import { i18nBusiness } from './business.i18n';
import { i18nCasePage } from './case.i18n';
import { i18nComponents } from './components.i18n';
import { i18nConditionDeviationPage } from './conditionDeviation.i18n';
import { i18nEventPage } from './event.i18n';
import { i18nDatetimeFormats } from './formats.i18n';
import { i18nGlossary } from './glossary.i18n';
import { i18nHomePage } from './home.i18n';
import { i18nMessages } from './messages.i18n';
import { i18nModelPage } from './model.i18n';
import { i18nMonitoringPage } from './monitoring.i18n';
import { i18nPdfPage } from './pdf.i18n';
import { i18nRecordsPage } from './records.i18n';
import { i18nReportsPage } from './reports.i18n';
import { i18nSensorsPage } from './sensors.i18n';
import { i18nVetPage } from './vet.i18n';
import { i18nChat } from './chat.i18n';

export const ptBR = {
  alarm_page: i18nAlarmPage,
  asset_page: i18nAssetPage,
  business: i18nBusiness,
  components: i18nComponents,
  case: i18nCasePage,
  glossary: i18nGlossary,
  messages: i18nMessages,
  model_page: i18nModelPage,
  sensors_page: i18nSensorsPage,
  vet_page: i18nVetPage,
  event_page: i18nEventPage,
  monitoring: i18nMonitoringPage,
  formats: i18nDatetimeFormats,
  home: i18nHomePage,
  conditionDeviation: i18nConditionDeviationPage,
  reports: i18nReportsPage,
  pdf: i18nPdfPage,
  records: i18nRecordsPage,
  chat: i18nChat,
};
